// Device artwork — a direct port of Flutter's imagePathReturn(devid)
// (homeScreenFunctions.dart). The PNGs are the same files, copied from the
// Flutter app into public/assets/images/png/.
//
// Keep this list in step with deviceMeta.js: every DeviceID that maps to a
// control screen should also map to a picture here.

import { BLE_WWH_DEVICE_ID, SCENE_CONTROLLER_DEVICE_ID, ONE_TOUCH_IDS, DOOR_LOCK_IDS } from './deviceMeta';

const P = '/assets/images/png';

export const SPLASH_IMAGE = `${P}/splash.png`;
export const BACKGROUND_IMAGE = '/assets/images/jpg/background.jpg';
export const QR_LOGO_IMAGE = `${P}/qrimg.png`;

export function deviceImage(deviceId) {
  const id = Number(deviceId);
  if (id === 49) return `${P}/4touch.png`;
  if (id === 23) return `${P}/wwrgb.png`;
  if (id === 53) return `${P}/fantouch.png`;
  if (id === 56) return `${P}/2touch.png`;
  if (ONE_TOUCH_IDS.includes(id)) return `${P}/1touch.png`;
  if (DOOR_LOCK_IDS.includes(id)) return `${P}/doorLock.png`;
  if (id === 51) return `${P}/curtain.png`;
  if (id === 24) return `${P}/rgb.png`;
  if (id === 25 || id === 90) return `${P}/wwh.png`;
  // The BLE lamp group is a white/warm light too; same artwork.
  if (id === BLE_WWH_DEVICE_ID) return `${P}/wwh.png`;
  // A 4 Scene Controller is a four-button touch panel; the 4 Touch artwork fits.
  if (id === SCENE_CONTROLLER_DEVICE_ID) return `${P}/4touch.png`;
  // 4+1 and 7+1 combined switch+fan panels reuse the 4 Touch artwork — the
  // Flutter app does the same; there is no dedicated asset yet.
  if (id === 92 || id === 93) return `${P}/4touch.png`;
  if (id === 82 || id === 16) return `${P}/graph.png`;
  return SPLASH_IMAGE;
}
